import * as React from "react";
import { useState, useMemo } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import useFeature from "hooks/useFeature";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Input, Button } from "components/bootstrap";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import { useAddEvidence, useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useHistory from "routing/useHistory";
import { isPermitted } from "util/PermissionsMixin";
import { Row, FormGroup, EvidenceList, EvidenceRow, IconButton, StyledLink } from "../styled.components";
function Searches({ investigation }) {
  const { permissions } = useCurrentUser();
  const [newSearchId, setNewSearchId] = useState("");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteSearchId, setDeleteSearchId] = useState(null);
  const history = useHistory();
  const isRightSidebarEnabled = useFeature("investigation_right_sidebar");
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const showAddForm = canManageEvidence && !isRightSidebarEnabled;
  const { addEvidence } = useAddEvidence();
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const isFormValid = useMemo(() => newSearchId && newSearchId.replace(/\s/g, "").length > 0, [newSearchId]);
  const onAddSearch = async (e) => {
    e.preventDefault();
    if (isFormValid) {
      await addEvidence({ invId: investigation.id, payload: { searches: [newSearchId] } });
    }
    setNewSearchId("");
  };
  const removeSearch = async () => {
    await removeEvidence({ invId: investigation.id, payload: { searches: [deleteSearchId] } });
    setShowDeleteDialog(false);
    setDeleteSearchId(null);
  };
  const onDelete = (searchId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteSearchId(searchId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteSearchId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showAddForm && /* @__PURE__ */ React.createElement("form", { onSubmit: onAddSearch }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "add-search-id",
      type: "text",
      label: "Add Search",
      "data-testid": "add-search-id",
      autoComplete: "off",
      placeholder: "Enter search ID",
      value: newSearchId,
      onChange: (e) => setNewSearchId(e.target.value)
    }
  )), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", onClick: onAddSearch, disabled: !isFormValid }, "Add"))), /* @__PURE__ */ React.createElement(EvidenceList, null, investigation.searches.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "gray" } }, "There are no searches to list") : investigation.searches.map((search) => /* @__PURE__ */ React.createElement(EvidenceRow, { key: search.id, $fullWidth: true, $gap: "0" }, canManageEvidence && /* @__PURE__ */ React.createElement(IconButton, { $danger: true, "data-testid": `delete-${search.id}`, onClick: onDelete(search.id) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })), /* @__PURE__ */ React.createElement(StyledLink, { onClick: () => history.push(Routes.VIEWS.VIEWID(search.id)) }, search.title)))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Search",
      onConfirm: removeSearch,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Search?"
  ));
}
export default Searches;
